import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface Props {
  image: string;
}

const useStyles = makeStyles<Theme, Props>((theme) =>
  createStyles({
    container: {
      width: '100%',
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      position: 'absolute',
      top: 0,

      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(2, 0),
        position: 'unset',
      },

      '& h2': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(22),
        fontWeight: theme.typography.fontWeightBold,

        '&#cancelled-title': {
          color: theme.palette.error.main,
        },

        '&#done-title': {
          fontSize: theme.typography.pxToRem(18),
          color: theme.palette.primary.contrastText,
        },

        [theme.breakpoints.only('sm')]: {
          marginBottom: theme.spacing(4),
        },
      },
    },

    contentWrapper: {
      paddingBottom: theme.spacing(2),

      [theme.breakpoints.up('sm')]: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
        border: '1px solid #EBEBEB',
        borderRadius: 13,
        background: '#FAFAFA',
      },
    },

    contentHeader: {
      minHeight: 80,

      backgroundColor: theme.palette.primary.light,
      backgroundImage: ({ image }) => `url(${image})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '1%',
      borderRadius: theme.spacing(1.8, 1.8, 0, 0),

      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(2),
      },

      '& > div': {
        padding: theme.spacing(2, 0, 0, 13),
        justifyContent: 'space-between',
      },
      '& h3, & p': {
        color: theme.palette.primary.contrastText,
      },
      '& h3': {
        fontSize: theme.typography.pxToRem(13),
      },
    },

    dataContainer: {
      minHeight: '40vh',
      marginTop: theme.spacing(4),
      padding: theme.spacing(0, 2),
      display: 'flex',

      justifyContent: 'space-evenly',

      [theme.breakpoints.up('md')]: {
        marginTop: 'unset',
        minHeight: 'unset',
        flexDirection: 'row',
      },

      '& h3': {
        marginBottom: theme.spacing(1),
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
      },
      '& h4': {
        color: theme.palette.text.secondary,
        fontSize: theme.typography.pxToRem(13),
        fontWeight: theme.typography.fontWeightBold,
      },
    },

    buttonContainer: {
      marginTop: theme.spacing(4),
      justifyContent: 'center',
    },
    formButton: {
      color: theme.palette.primary.contrastText,
      fontWeight: theme.typography.fontWeightBold,
      textTransform: 'initial',
      textDecoration: 'underline',

      '&:hover': {
        textDecoration: 'underline',
      },
    },
    cancelled: {
      margin: 'auto 0',
      padding: theme.spacing(0.5),
      color: theme.palette.error.main,
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightBold,
      borderRadius: 3,
      background: 'white',
    },
  })
);

export default useStyles;
